/**
 * Announcements API endpoints
 */

import { fetchApi } from '../core';
import type {
  AnnouncementResponse,
  CreateAnnouncementData,
  PinAnnouncementData,
  UpdateAnnouncementData,
} from '../types';

export function listForCourse(courseId: string, componentName: string = 'Unknown') {
  return fetchApi<AnnouncementResponse[]>(
    `/courses/${courseId}/announcements`,
    {},
    componentName
  );
}

export function create(
  courseId: string,
  data: CreateAnnouncementData,
  componentName: string = 'Unknown'
) {
  return fetchApi<AnnouncementResponse>(
    `/courses/${courseId}/announcements`,
    { method: 'POST', body: JSON.stringify(data) },
    componentName
  );
}

export function update(
  announcementId: string,
  data: UpdateAnnouncementData,
  componentName: string = 'Unknown'
) {
  return fetchApi<AnnouncementResponse>(
    `/announcements/${announcementId}`,
    { method: 'PUT', body: JSON.stringify(data) },
    componentName
  );
}

export function pin(
  announcementId: string,
  data: PinAnnouncementData,
  componentName: string = 'Unknown'
) {
  return fetchApi<AnnouncementResponse>(
    `/announcements/${announcementId}/pin`,
    { method: 'POST', body: JSON.stringify(data) },
    componentName
  );
}

export function remove(announcementId: string, componentName: string = 'Unknown') {
  return fetchApi<{ message: string }>(
    `/announcements/${announcementId}`,
    { method: 'DELETE' },
    componentName
  );
}
